import { createSelector, defaultMemoize, createSelectorCreator, } from 'reselect';
import { userSchema } from '../normalizr/schemas/user';
import { getDataEntityById, getAllDataEntitiesForSchema, getDataEntities, } from '../entities';
import objValues from 'lodash/values';
import memoize from 'lodash/memoize';
import { selectors as streamSelectors } from '../../Stream';
import { denormalize } from 'normalizr';
export var getUserById = defaultMemoize(function (state, id) {
    return getDataEntityById(state, userSchema, id);
});
export var getUsersByUsernames = createSelector([
    function (state) { return getAllDataEntitiesForSchema(state, userSchema); },
    function (state, usernames) {
        if (usernames === void 0) { usernames = []; }
        return usernames.map(function (username) { return username.toLowerCase(); });
    },
], function (usersKeyedByIds, usernames) {
    return objValues(usersKeyedByIds).filter(function (user) {
        return usernames.includes(user.username.toLowerCase());
    });
});
export var getUsersByIds = createSelector([
    function (state) { return getAllDataEntitiesForSchema(state, userSchema); },
    function (state, ids) { return ids; },
], function (usersKeyedByIds, ids) { return ids.map(function (id) { return usersKeyedByIds[id]; }); });
// lodash memoize allows us to create an unbounded memo cache for the denormalized
// items, which is needed because we may end up with multiple different streams on a page.
// To keep the streams GC-able, we set memoize to use WeakMap for its cache
// note that in this simple setup, the whole state is used for the memo key resolution,
// meaning each store update resets the memo - which is fine for now, but can possibly be
// optimized by somehow hashing only stream-related stuff
memoize.Cache = WeakMap;
var heavilyCachedSelectorCreator = createSelectorCreator(memoize);
/**
 * You should use this when selecting users into a list inside redux container
 */
export var getDenormalizedStreamUsers = heavilyCachedSelectorCreator([
    function (state, streamId) { return streamSelectors.getItems(state, streamId); },
    function (state) { return getDataEntities(state); },
], function (items, entities) {
    if (items === void 0) { items = []; }
    if (entities === void 0) { entities = {}; }
    return denormalize(items, userSchema, entities);
});
//# sourceMappingURL=selectors.js.map